import {getPrivateAxios} from '../../libs';
import {Guide} from './types';

export const fetchGuide = async (id: string) => {
  return getPrivateAxios()
    .get<Guide>(`/guides/${id}`)
    .then((response) => {
      return response.data;
    });
};
